export default {
  universalModal: state => state.universalModal,
  deleteModal: state => state.deleteModal,
  id: state => state.id,
}